import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-twitter',
  templateUrl: 'twitter.html'
})
export class TwitterPage {

  client: any;
  event: any;
  dataSocial: any;
  isSpinner: any = true;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataSocial = this.params.get('social');

    setTimeout(() => {
      this.isSpinner = false;
    }, 2000);

  }

  ngAfterViewInit() {
    !function(d: any, s: any, id: any){
      var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';
      // if(!d.getElementById(id)){
      js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js,fjs);
      // }
    }(document,"script","twitter-wjs");
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-social/twitter/twitter.ts